import {Observable} from 'rxjs';
import {Category} from '@spartacus/core';

export abstract class CustomCategoryAdapter {
    abstract load(code): Observable<Category>;
}
